import {
    Center,
    Group
} from "@mantine/core";
import {
    FlexiButton,
    PlatformFieldset
} from "@flexinet/ui-components";
import {AiOutlineGoogle,} from "react-icons/ai";
import {
    signInWithRedirect,
    SignInWithRedirectInput
} from "aws-amplify/auth";

// REGISTRATION-PAUSE (FNP-1222) — TEMPORARY: remove with the guard below.
import {isRegistrationEnabled} from "../../../../config/registration";


export const SocialSignUpFieldset = () => {

    // REGISTRATION-PAUSE (FNP-1222) — TEMPORARY: federated sign-up creates a
    // pool user on first login without ever submitting the form, so it is
    // hidden while registration is closed. The sign-in page keeps its Google
    // button by decision, so existing federated users can still sign in.
    // Remove this guard and its import to restore. See src/config/registration.ts.
    if (!isRegistrationEnabled()) {
        return null;
    }

    const googleSignInWithRedirectInput = {provider: 'Google'} as SignInWithRedirectInput

    return (
        <PlatformFieldset legend={'Sign Up with Social Account'}
                          px={'xl'}
                          mb={'xl'}>
            <Center>
                <Group
                    my={'lg'}
                >
                    <FlexiButton variant={'outline'} size={'xl'} radius={'sm'}
                                 leftSection={<AiOutlineGoogle size={'1.6em'}/>}
                                 onClick={(e) => {
                                     e.preventDefault()
                                     signInWithRedirect(googleSignInWithRedirectInput)
                                 }}>Google</FlexiButton>


                </Group>
            </Center>
        </PlatformFieldset>

    )
}

